<template>
    <div class="journal-card" v-if="periodico">
        <template v-if="user">
            <template v-if="isPdf && hasPdfRoute">
                <router-link :to="{ name: 'LeitorPdf', params: { idPeriodico: periodico.idPeriodico } }"
                             class="card-link"
                             @click="geraLog">
                    <div class="card-cover">
                        <div class="card-badge" v-if="badgeTexto">
                            {{ badgeTexto }}
                        </div>

                        <div class="book-wrap">
                            <div class="book">
                                <div class="book__cover">
                                    <img :src="periodico.urlImgPeriodico"
                                         :alt="periodico.dsTitulo"
                                         class="book__cover-img"
                                         @error="onImgError" />
                                </div>
                                <div class="book__spine"></div>
                                <div class="book__pages"></div>
                                <div class="book__shadow"></div>
                            </div>
                        </div>
                    </div>

                    <div class="card-info">
                        <span class="card-pub">{{ nomePublicacao }}</span>

                        <div class="card-title">
                            {{ periodico.dsTitulo }}
                        </div>

                        <p class="card-desc">
                            {{ periodico.dsPeriodico }}
                        </p>

                        <div class="card-footer">
                            <span class="card-date">{{ dataTexto }}</span>
                            <span class="card-btn">Ler agora →</span>
                        </div>
                    </div>
                </router-link>
            </template>

            <template v-else-if="!isPdf">
                <router-link :to="{ name: 'Revista', params: { idPeriodico: periodico.idPeriodico } }"
                             class="card-link"
                             @click="geraLog">
                    <div class="card-cover">
                        <div class="card-badge" v-if="badgeTexto">
                            {{ badgeTexto }}
                        </div>

                        <div class="book-wrap">
                            <div class="book">
                                <div class="book__cover">
                                    <img :src="periodico.urlImgPeriodico"
                                         :alt="periodico.dsTitulo"
                                         class="book__cover-img"
                                         @error="onImgError" />
                                </div>
                                <div class="book__spine"></div>
                                <div class="book__pages"></div>
                                <div class="book__shadow"></div>
                            </div>
                        </div>
                    </div>

                    <div class="card-info">
                        <span class="card-pub">{{ nomePublicacao }}</span>

                        <div class="card-title">
                            {{ periodico.dsTitulo }}
                        </div>

                        <p class="card-desc">
                            {{ periodico.dsPeriodico }}
                        </p>

                        <div class="card-footer">
                            <span class="card-date">{{ dataTexto }}</span>
                            <span class="card-btn">Ler agora →</span>
                        </div>
                    </div>
                </router-link>
            </template>

            <template v-else>
                <div class="card-link card-link-disabled">
                    <div class="card-cover">
                        <div class="card-badge" v-if="badgeTexto">
                            {{ badgeTexto }}
                        </div>

                        <div class="book-wrap">
                            <div class="book">
                                <div class="book__cover">
                                    <img :src="periodico.urlImgPeriodico"
                                         :alt="periodico.dsTitulo"
                                         class="book__cover-img"
                                         @error="onImgError" />
                                </div>
                                <div class="book__spine"></div>
                                <div class="book__pages"></div>
                                <div class="book__shadow"></div>
                            </div>
                        </div>
                    </div>

                    <div class="card-info">
                        <span class="card-pub">{{ nomePublicacao }}</span>

                        <div class="card-title">
                            {{ periodico.dsTitulo }}
                        </div>

                        <p class="card-desc">
                            {{ periodico.dsPeriodico }}
                        </p>

                        <div class="card-footer">
                            <span class="card-date">{{ dataTexto }}</span>
                            <span class="card-btn">Arquivo indisponível</span>
                        </div>
                    </div>
                </div>
            </template>
        </template>

        <template v-else>
            <div class="card-link card-link-guest" @click="irParaPlanos">
                <div class="card-cover">
                    <div class="card-badge" v-if="badgeTexto">
                        {{ badgeTexto }}
                    </div>

                    <div class="book-wrap">
                        <div class="book">
                            <div class="book__cover">
                                <img :src="periodico.urlImgPeriodico"
                                     :alt="periodico.dsTitulo"
                                     class="book__cover-img"
                                     @error="onImgError" />
                            </div>
                            <div class="book__spine"></div>
                            <div class="book__pages"></div>
                            <div class="book__shadow"></div>
                        </div>
                    </div>

                    <div class="card-lock">
                        <span class="lock-cta">Assine para ler</span>
                    </div>
                </div>

                <div class="card-info">
                    <span class="card-pub">{{ nomePublicacao }}</span>

                    <div class="card-title">
                        {{ periodico.dsTitulo }}
                    </div>

                    <p class="card-desc">
                        {{ periodico.dsPeriodico }}
                    </p>

                    <div class="card-footer">
                        <span class="card-date">{{ dataTexto }}</span>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        name: 'BoxPeriodico',

        props: {
            periodico: {
                type: Object,
                required: true,
            },
        },

        computed: {
            user() {
                return this.$store.state.user
            },

            hasPdfRoute() {
                return this.periodico?.idPeriodico != null
            },

            isPdf() {
                return this.periodico.tpPublicacao == null || this.periodico.tpPublicacao === 'upload'
            },

            nomePublicacao() {
                if (this.periodico.nmTipoPeriodico) return this.periodico.nmTipoPeriodico
                if (this.periodico.dsTipoPeriodico) return this.periodico.dsTipoPeriodico
                if (this.periodico.tipoPeriodico?.nmTipoPeriodico) return this.periodico.tipoPeriodico.nmTipoPeriodico
                return 'Periódico'
            },

            badgeTexto() {
                if (this.periodico.dsMesAno) return this.periodico.dsMesAno
                if (this.periodico.mesAno) return this.periodico.mesAno
                if (this.periodico.dtPublicacaoFormatada) return this.periodico.dtPublicacaoFormatada

                if (this.periodico.dtPublicacao) {
                    const data = new Date(this.periodico.dtPublicacao)
                    if (!isNaN(data.getTime())) {
                        const meses = ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ']
                        return `${meses[data.getMonth()]} ${data.getFullYear()}`
                    }
                }

                return 'RECENTE'
            },

            dataTexto() {
                if (this.periodico.dsMesAnoExtenso) return this.periodico.dsMesAnoExtenso
                if (this.periodico.dataExtenso) return this.periodico.dataExtenso

                if (this.periodico.dtPublicacao) {
                    const data = new Date(this.periodico.dtPublicacao)
                    if (!isNaN(data.getTime())) {
                        const meses = [
                            'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
                            'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
                        ]
                        return `${meses[data.getMonth()]} · ${data.getFullYear()}`
                    }
                }

                return 'Edição disponível'
            },
        },

        methods: {
            geraLog() {
            },

            irParaPlanos() {
                this.geraLog()
                this.$router.push({ name: 'Planos' })
            },

            onImgError(e) {
                e.target.onerror = null
                e.target.src = '/image-not-found.jpg'
            },
        },
    }
</script>

<style lang="scss" scoped>
    .journal-card {
        --gold: #C8922A;
        --gold-light: #E8A83A;
        --dark: #1A1A2E;
        --dark-mid: #2a2a42;
        --muted: #7a7060;
        --border: #DEDBD4;
        --border-gold: rgba(200, 146, 42, 0.3);
        --shadow-sm: 0 2px 8px rgba(26, 26, 46, 0.07);
        --shadow-lg: 0 20px 60px rgba(26, 26, 46, 0.14);
        background: #fff;
        border: 1px solid var(--border);
        border-radius: 12px;
        overflow: hidden;
        cursor: pointer;
        transition: transform 0.3s, border-color 0.3s, box-shadow 0.3s;
        position: relative;
        display: flex;
        flex-direction: column;
        height: 100%;
        box-shadow: var(--shadow-sm);
    }

    .journal-card:hover {
        transform: translateY(-6px);
        border-color: var(--gold);
        box-shadow: var(--shadow-lg), 0 0 0 1px var(--border-gold);
    }

    .card-link,
    .card-link:hover,
    .card-link:focus,
    .card-link:active {
        text-decoration: none !important;
        color: inherit !important;
        display: flex;
        flex-direction: column;
        height: 100%;
    }

    .card-link-guest {
        cursor: pointer;
    }

    .card-cover {
        position: relative;
        overflow: hidden;
        aspect-ratio: 3 / 4;
        background: radial-gradient(circle at 50% 35%, rgba(200, 146, 42, 0.07) 0%, transparent 55%), linear-gradient(180deg, #e8e3d8 0%, #ddd8cc 55%, #ccc7bc 100%);
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 1.1rem;
        border-bottom: 1px solid var(--border);
    }

    .card-badge {
        position: absolute;
        top: 0.75rem;
        right: 0.75rem;
        background: var(--gold);
        color: #fff;
        font-size: 0.65rem;
        font-weight: 700;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        padding: 0.3rem 0.6rem;
        border-radius: 4px;
        z-index: 5;
    }

    /* Livro 3D */
    .book-wrap {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        perspective: 900px;
        z-index: 2;
        transition: transform 0.35s ease;
    }

    .journal-card:hover .book-wrap {
        transform: translateY(-4px);
    }

    .book {
        position: relative;
        width: 72%;
        max-width: 250px;
        aspect-ratio: 3 / 4;
        transform: rotateY(-20deg) rotateX(4deg);
        transform-style: preserve-3d;
        transition: transform 0.45s cubic-bezier(0.22, 0.68, 0, 1.2);
    }

    .journal-card:hover .book {
        transform: rotateY(-12deg) rotateX(2deg) scale(1.06);
    }

    .book__cover {
        position: absolute;
        inset: 0;
        overflow: hidden;
        border-radius: 2px 7px 7px 2px;
        background: #111;
        box-shadow: 2px 0 6px rgba(0, 0, 0, 0.35), 10px 18px 28px rgba(0, 0, 0, 0.18), inset 2px 0 0 rgba(255, 255, 255, 0.08), inset -1px 0 0 rgba(0, 0, 0, 0.45);
    }

    .book__cover::after {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: inherit;
        background: linear-gradient(135deg, rgba(255, 255, 255, 0.16) 0%, rgba(255, 255, 255, 0.05) 24%, transparent 52%);
        pointer-events: none;
        z-index: 1;
    }

    .book__cover-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center top;
        display: block;
    }

    .book__spine {
        position: absolute;
        top: 2px;
        bottom: 2px;
        left: -12px;
        width: 12px;
        border-radius: 2px 0 0 2px;
        transform-origin: right center;
        transform: rotateY(-90deg);
        background: linear-gradient(180deg, #8a7040 0%, #5a4820 100%);
        box-shadow: inset -1px 0 0 rgba(255, 255, 255, 0.06);
    }

    .book__spine::after {
        content: '';
        position: absolute;
        top: 12px;
        bottom: 12px;
        left: 5px;
        width: 1px;
        background: rgba(255, 255, 255, 0.18);
    }

    .book__pages {
        position: absolute;
        top: 3px;
        bottom: 3px;
        right: -7px;
        width: 7px;
        border-radius: 0 2px 2px 0;
        background: repeating-linear-gradient(180deg, #ece7df 0px, #ece7df 1px, #dbd6cf 1px, #dbd6cf 2px);
        box-shadow: 2px 0 4px rgba(0, 0, 0, 0.18);
        transform-origin: left center;
        transform: rotateY(90deg) translateX(3px);
    }

    .book__shadow {
        position: absolute;
        bottom: -18px;
        left: -10px;
        right: -6px;
        height: 24px;
        border-radius: 50%;
        background: rgba(26, 26, 46, 0.2);
        filter: blur(10px);
        transform: scaleX(1.06) skewX(-8deg);
        z-index: -1;
    }

    .card-lock {
        position: absolute;
        inset: 0;
        background: linear-gradient(to top, rgba(26, 26, 46, 0.88) 0%, rgba(26, 26, 46, 0.25) 60%, transparent 100%);
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;
        padding-bottom: 1.5rem;
        gap: 0.75rem;
        opacity: 0;
        transition: opacity 0.3s;
        z-index: 4;
    }

    .journal-card:hover .card-lock {
        opacity: 1;
    }

    .lock-cta {
        font-size: 0.75rem;
        font-weight: 600;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        background: var(--gold);
        color: #fff;
        padding: 0.5rem 1.25rem;
        border-radius: 4px;
    }

    .card-info {
        padding: 1.25rem 1.25rem 1.5rem;
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        background: #fff;
    }

    .card-pub {
        font-size: 0.65rem;
        font-weight: 600;
        letter-spacing: 0.12em;
        text-transform: uppercase;
        color: var(--gold);
        display: block;
    }

    .card-title {
        font-family: 'Playfair Display', serif;
        font-size: 1rem;
        line-height: 1.35;
        font-weight: 700;
        color: var(--dark);
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        min-height: 2.7em;
    }

    .card-desc {
        font-size: 0.8rem;
        color: var(--muted);
        line-height: 1.5;
        flex: 1;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        min-height: 3.8em;
        margin: 0;
    }

    .card-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 0.75rem;
        gap: 0.75rem;
    }

    .card-date {
        font-size: 0.7rem;
        color: var(--muted);
    }

    .card-btn {
        font-size: 0.68rem;
        font-weight: 600;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        color: var(--gold);
        text-decoration: none;
        display: flex;
        align-items: center;
        gap: 0.3rem;
        transition: gap 0.2s;
        white-space: nowrap;
    }

    .journal-card:hover .card-btn {
        gap: 0.5rem;
    }

    @media (max-width: 575.98px) {
        .card-info {
            padding: 1rem 1rem 1.2rem;
        }

        .card-title {
            font-size: 0.95rem;
        }

        .card-desc {
            font-size: 0.78rem;
        }

        .book {
            width: 58%;
            max-width: 145px;
        }
    }
</style>